import { AwEvent } from "../models/AwEvent"
import axios from "axios"
import { RootLogger } from "loglevel"
export function SendAnalytics(
  event: AwEvent,
  url: string,
  logger: RootLogger | undefined
) {
  axios({
    method: "post",
    url: url,
    data: event
  }).catch(function (error) {
    if (logger) logger.error(error)
  })
}
